import { parseScenario } from '../loaders';
import type { Scenario } from '../schemas';

const RAW: unknown[] = [
  {
    id: 'ball-plus-totem',
    number: 1,
    title: 'Ball + totem',
    description:
      'One explosion hits the TURQUOISE ball and totem. The ball is stunned and the totem loses 1 life.',
    map: 'arena',
    seed: 1,
    durationTicks: 2,
    setup: {
      players: {
        ORANGE: { x: 0.5, y: 5.5 },
        TURQUOISE: { x: 3.5, y: 9.5 },
      },
      goldens: [{ x: 3.5, y: 8.5, status: 'ARMED', fuseRemainingTicks: 1, toucher: 'ORANGE' }],
    },
  },
  {
    id: 'chain-reaction',
    number: 2,
    title: 'Chain reaction',
    description: 'An exploding ball pulls a nearby armed fuse forward to currentTick + 6.',
    map: 'arena',
    seed: 2,
    durationTicks: 8,
    setup: {
      players: {
        ORANGE: { x: 0.5, y: 0.5 },
        TURQUOISE: { x: 7.5, y: 10.5 },
      },
      goldens: [
        { x: 3.5, y: 3.5, status: 'ARMED', fuseRemainingTicks: 1 },
        { x: 5.5, y: 3.5, status: 'ARMED', fuseRemainingTicks: 120 },
      ],
    },
  },
  {
    id: 'friendly-fire',
    number: 3,
    title: 'Friendly fire',
    description: 'ORANGE is hit by a bomb they armed and is stunned; no point is awarded.',
    map: 'arena',
    seed: 3,
    durationTicks: 2,
    setup: {
      players: {
        ORANGE: { x: 5.5, y: 4.5 },
        TURQUOISE: { x: 7.5, y: 10.5 },
      },
      goldens: [{ x: 3.5, y: 4.5, status: 'ARMED', fuseRemainingTicks: 1, toucher: 'ORANGE' }],
    },
  },
  {
    id: 'double-destruction',
    number: 4,
    title: 'Double destruction',
    description: 'Both totems fall on the same tick; sudden death begins with one life each.',
    map: 'arena',
    seed: 4,
    durationTicks: 2,
    setup: {
      totemHp: { ORANGE: 1, TURQUOISE: 1 },
      players: {
        ORANGE: { x: 0.5, y: 0.5 },
        TURQUOISE: { x: 7.5, y: 10.5 },
      },
      goldens: [
        { x: 3.5, y: 2.5, status: 'ARMED', fuseRemainingTicks: 1 },
        { x: 3.5, y: 8.5, status: 'ARMED', fuseRemainingTicks: 1 },
      ],
    },
  },
  {
    id: 'overtime-last-blast',
    number: 5,
    title: 'Overtime last blast',
    description: 'A bomb detonating at 0:00 still damages; overtime waits for the lethal window.',
    map: 'arena',
    seed: 5,
    durationTicks: 20,
    setup: {
      phase: 'OVERTIME',
      players: {
        ORANGE: { x: 0.5, y: 0.5 },
        TURQUOISE: { x: 7.5, y: 10.5 },
      },
      goldens: [{ x: 3.5, y: 2.5, status: 'ARMED', fuseRemainingTicks: 1, toucher: 'TURQUOISE' }],
    },
  },
  {
    id: 'open-arena',
    number: 6,
    title: 'Open arena',
    description: 'Standard match start without countdown, for feel tests.',
    map: 'arena',
    seed: 8,
    durationTicks: 3600,
    setup: { phase: 'REGULATION' },
  },
];

export const SCENARIOS: readonly Scenario[] = RAW.map((raw) => parseScenario(raw)).sort(
  (a, b) => a.number - b.number,
);

export function getScenario(id: string): Scenario {
  const scenario = SCENARIOS.find((s) => s.id === id);
  if (!scenario) throw new Error(`Unknown scenario "${id}"`);
  return scenario;
}
